export const audioRecorder = {
  data() {
    return {
      isRecording: false,
      audioBlob:   null,
      error:       null,
    }
  },

  watch: {
    audioBlob(blob) {
      if (blob) this.onAudioReady(blob)
    }
  },

  methods: {
    async startRecording() {
      this.error      = null
      this.audioBlob  = null
      this._cancelled = false
      try {
        const stream = await navigator.mediaDevices
          .getUserMedia({ audio: true })

        this._chunks = []
        this._mediaRecorder = new MediaRecorder(stream, {
          mimeType: 'audio/webm;codecs=opus'
        })

        this._mediaRecorder.ondataavailable = (e) => {
          if (e.data.size > 0) this._chunks.push(e.data)
        }

        this._mediaRecorder.onstop = () => {
          if (!this._cancelled) {
            this.audioBlob = new Blob(this._chunks, { type: 'audio/webm' })
          }
          stream.getTracks().forEach(t => t.stop())
        }

        this._mediaRecorder.start()
        this.isRecording = true

      } catch (err) {
        this.error = err.message
      }
    },

    stopRecording() {
      this._cancelled = false
      if (this._mediaRecorder) this._mediaRecorder.stop()
      this.isRecording = false
    },

    cancelRecording() {
      this._cancelled = true
      if (this._mediaRecorder) this._mediaRecorder.stop()
      this.isRecording = false
    },

    // override en el componente que use el mixin
    onAudioReady(blob) {}
  }
}